module.exports = __webpack_public_path__ + "img/upmood_icon.e66136dd.png";